import React from 'react';
import styled from 'styled-components';

import SupportModal from '@components/Console/SupportModal';
import Button from '@shared/Button';
import { ReactComponent as QuestionAnswerIcon } from '@src/assets/escher/icons/question-answer.svg';
import A from '@styled/Elements/A';

export default function Footer() {
  const [modalOpen, toggleModalOpen] = React.useState(false);
  const handleModalToggle = () => {
    toggleModalOpen(!modalOpen);
  };

  return (
    <FooterContainer>
      <FooterRow>
        <LegalLink
          href={process.env.REACT_APP_PRIVACY_POLICY_URL}
          target='_blank'
        >
          Privacy Policy
        </LegalLink>
        <Button
          analyticsName='Footer - Contact Support'
          ml={1}
          size='xs'
          variant='tertiary'
          onClick={handleModalToggle}
        >
          <FeedbackIcon />
          <span>Contact Support</span>
        </Button>
        <SupportModal isOpen={modalOpen} handleTeardown={handleModalToggle} />
      </FooterRow>
    </FooterContainer>
  );
}

const FooterContainer = styled.div`
  align-items: flex-end;
  display: flex;
  flex-grow: 1;
  justify-content: flex-end;
  margin: 24px 0;
`;

const FooterRow = styled.div`
  align-items: center;
  display: flex;
`;

const LegalLink = styled(A)`
  color: ${props => props.theme.fontTertiary};
  font-size: 12px;
`;

const FeedbackIcon = styled(QuestionAnswerIcon)`
  width: 13px;
`;
